namespace TabAurous {
    export interface IssuesRequest extends Serenity.ServiceRequest {
        Issues?: TabAurous.Common.Issue[];
        RateIssues?: TabAurous.Common.RateIssues[];
    }
}
